export default "__VITE_ASSET__DH9wqivR__"